import { ReactNode } from 'react';

type NewPageContainerProps = {
    children: ReactNode | ReactNode[];
};

function NewPageContainer({ children }: NewPageContainerProps): JSX.Element {
    return <div className="py-8 bg-gray-50 dark:bg-gray-900 min-h-[var(--remaining-screen-height)]">{children}</div>;
}

export default NewPageContainer;
